module.exports = __webpack_public_path__ + "img/icon-3.dc8a6dff.svg";